import styles from "./SaleTagIcon.module.scss";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

type SaleTagIconProps = {
  type: "small" | "medium" | "stroke";
  isBlackOverride?: boolean;
};

export const SaleTagIcon = ({
  type = "small",
  isBlackOverride = false,
}: SaleTagIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cx(styles.saleTag, {
        smallSaleTag: type === "small",
        mediumSaleTag: type === "medium",
        strokeSaleTag: type === "stroke",
        blackOverride: isBlackOverride,
      })}
      data-testid={`sale-tag-icon-${type}`}
    >
      {type === "medium" && (
        <path d="M1.69923 1.69924L10.5381 1.69955L20.3948 11.5562L11.5559 20.395L1.69931 10.5384L1.69923 1.69924ZM6.87697 10.7776C9.03088 10.7776 10.777 9.03153 10.777 6.87762C10.777 4.72371 9.03088 2.97762 6.87697 2.97762C4.72306 2.97762 2.97697 4.72371 2.97697 6.87762C2.97697 9.03153 4.72306 10.7776 6.87697 10.7776Z" />
      )}
      {type === "small" && (
        <path d="M1.07032 1.56643L6.64237 1.56663L12.9988 7.92306L7.4268 13.4951L1.07038 7.13863L1.07032 1.56643ZM4.50375 7.25016C5.74639 7.25016 6.75375 6.2428 6.75375 5.00016C6.75375 3.75752 5.74639 2.75016 4.50375 2.75016C3.26111 2.75016 2.25375 3.75752 2.25375 5.00016C2.25375 6.2428 3.26111 7.25016 4.50375 7.25016Z" />
      )}
      {type === "stroke" && (
        <path d="M9.16306 1.4699L8.9434 1.25024L8.63275 1.25023L2.00003 1.25L1.24999 1.24997L1.25 2.00001L1.25007 8.6329L1.25007 8.94355L1.46974 9.16322L8.57616 16.2696L9.10649 16.8L9.63682 16.2696L16.2695 9.63698L16.7998 9.10665L16.2695 8.57632L9.16306 1.4699ZM6.93344 6.18375C6.93344 6.59796 6.59765 6.93375 6.18344 6.93375C5.76922 6.93375 5.43344 6.59796 5.43344 6.18375C5.43344 5.76954 5.76922 5.43375 6.18344 5.43375C6.59765 5.43375 6.93344 5.76954 6.93344 6.18375Z" />
      )}
    </svg>
  );
};
